export default __webpack_public_path__ + "static/media/icon-next-step-payment-participation-fees-gray.3c65d7dc.svg";